import {  DatasetPieProps } from 'components/dashboard/charts/interfaces';
import { defaultLoadConf } from 'components/dashboard/data-input-output-table/defaultConfigs';


const defaultDatasetPieChartConfig: DatasetPieProps = {
    identifiers: [],
    height: 400,
    showDateSelection: true,
    hideRefresh: false,
    loadConf: defaultLoadConf,
    updateFrequency: 5,
    datasets: [],
    toggleTracesGrouping: true,
    timeAxisStepSeconds: 0,
    chartsPerRow: 2,
    centerTextConfig: {
        fontSize: 15,
        decimalPlaces: 1
    },
    charts: []  
};

export default defaultDatasetPieChartConfig